import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ 'nav', 'track', 'slider', 'previous', 'next', 'content' ];

    connect() {
        // this.navTargets.forEach((item) => {
        //     item.addEventListener('click', (theNavItem) => {
        //         this.slideToImageByNav(theNavItem);
        //     });
        // })

        // this.previousTarget.addEventListener('click', () => {
        //     this.slideToPrevious();
        // });

        // this.nextTarget.addEventListener('click', () => {
        //     this.slideToNext();
        // });
    }

    slideToImageByNav(e) {
        //Width of track at the moment
        const sliderWidth = this.sliderTarget.offsetWidth;

        //Clicked nav item data key
        const key = e.target.dataset.key;

        const translateX = (key - 1) * sliderWidth;

        //Reset nav items - not current key
        this.setSlideContent(key);
        this.resetNavItems(key);
        this.resetButtons(key);
        
        //Set slider current index
        this.sliderTarget.dataset.currentKey = key;

        this.trackTarget.style.transform = 'translateX(-'+ translateX +'px)';
    }

    slideToPrevious(e) {
        e.preventDefault();

        //Width of track at the moment
        const sliderWidth = this.sliderTarget.offsetWidth;

        const currentSlide = this.sliderTarget.dataset.currentKey;

        const targetSlide = currentSlide - 1;

        const translateX = (targetSlide - 1) * sliderWidth;

        //Set slider current index
        this.sliderTarget.dataset.currentKey = targetSlide;

        //Reset nav items - not current key
        this.setSlideContent(targetSlide);
        this.resetNavItems(targetSlide);
        this.resetButtons(targetSlide);

        this.trackTarget.style.transform = 'translateX(-'+ translateX +'px)';
    }

    slideToNext(e) {
        e.preventDefault();

        //Width of track at the moment
        const sliderWidth = this.sliderTarget.offsetWidth;

        const currentSlide = this.sliderTarget.dataset.currentKey;

        const targetSlide = parseInt(currentSlide) + 1;

        const translateX = (targetSlide - 1) * sliderWidth;

        //Set slider current index
        this.sliderTarget.dataset.currentKey = targetSlide;

        //Reset nav items - not current key
        this.setSlideContent(targetSlide);
        this.resetNavItems(targetSlide);
        this.resetButtons(targetSlide);

        this.trackTarget.style.transform = 'translateX(-'+ translateX +'px)';
    }

    setSlideContent(key) {

        this.contentTargets.forEach((item) => {
            if(!item.classList.contains('pointer-events-none')) {
                item.classList.add('pointer-events-none', 'opacity-0', 'absolute')
                item.classList.remove('pointer-events-auto', 'opacity-100')
            }

            if(item.dataset.key == key) {
                if(item.classList.contains('pointer-events-none')) {
                    item.classList.remove('pointer-events-none', 'opacity-0', 'absolute')
                    item.classList.add('pointer-events-auto', 'opacity-100')
                }
            }
        });
    }

    resetButtons(key) {
        const previous = this.previousTarget;
        const next = this.nextTarget;
        const sliderLength = this.navTargets.length;

        // Previous button
        if(key == 1 && !previous.classList.contains('pointer-events-none')) {
            previous.classList.remove('pointer-events-auto','fill-green-500','text-green-500');
            previous.classList.add('pointer-events-none','fill-green-400','text-green-400');
        } else if (key != 1 && previous.classList.contains('pointer-events-none')) {
            previous.classList.remove('pointer-events-none','fill-green-400','text-green-400');
            previous.classList.add('pointer-events-auto','fill-green-500','text-green-500');
        }

        // Next button
        if(key == sliderLength && !next.classList.contains('pointer-events-none')) {
            next.classList.remove('pointer-events-auto','fill-green-500','text-green-500');
            next.classList.add('pointer-events-none','fill-green-400','text-green-400');
        } else if (key != sliderLength && next.classList.contains('pointer-events-none')) {
            next.classList.remove('pointer-events-none','fill-green-400','text-green-400');
            next.classList.add('pointer-events-auto','fill-green-500','text-green-500');
        }
    }

    resetNavItems(key) {

        this.navTargets.forEach((item) => {
            if (item.classList.contains('bg-green-400')) {
                item.classList.remove('bg-green-400');
                item.classList.add('bg-green-200');
            }

            if(item.dataset.key == key) {
                item.classList.remove('bg-green-200');
                item.classList.add('bg-green-400');
            }
        })
    }
}